import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterV2Component } from './filter-v2.component';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DateRangePickerPopoverModule } from 'src/app/lib/date-range-picker-popover/date-range-picker-popover.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import {
  ButtonModule,
  DropdownModule,
  InputsModule,
  ToggleModule
} from '@xref/xref-lib';
import {
  GooglePlacesLocationModule
} from "../../lib/google-places-location/google-places-location/google-places-location.module";
import {PlacesService} from "../../services/places/places.service";
import {
  DateRangePickerPopoverV2Module
} from "../../lib/app-date-range-picker-popover-v2/date-range-picker-popover-v2.module";



@NgModule({
  declarations: [FilterV2Component],
  imports: [
    CommonModule,
    FormsModule,
    DateRangePickerPopoverModule,
    DateRangePickerPopoverV2Module,
    BsDropdownModule.forRoot(),
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    PopoverModule.forRoot(),
    ToggleModule,
    GooglePlacesLocationModule,
    InputsModule,
    DropdownModule,
    ButtonModule
  ],
  providers:[PlacesService],
  exports: [FilterV2Component]
})
export class FilterV2Module { }
